/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewContainerRef} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {IfOpenService} from './if-open.service';
/**
 * *******
 * 
 * \@class IfOpenDirective
 * 
 * \@description 
 * A structural directive that controls whether or not the associated TemplateRef is instantiated or not.
 * It makes use of a Component instance level service: IfOpenService to maintain state between itself and the component
 * using it in the component template.
 * 
 */
export class IfOpenDirective implements OnDestroy {
private subscription: Subscription;
/**
 * ******
 * \@function open
 * 
 * \@description 
 * A setter that updates IfOpenService.open with value.
 * 
 * @param {?} value
 * @return {?}
 */
public set open(value: boolean) {
        this.ifOpenService.open = value;
    }
/**
 * *******
 * \@property openChange
 * 
 * \@description 
 * An event emitter that emits when the open property is set to allow for 2way binding when the directive is
 * used with de-structured / de-sugared syntax.
 * 
 */
openChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);
/**
 * *****
 * \@function open
 * 
 * \@description 
 * A getter that returns the current IfOpenService.open value.
 * @return {?}
 */
public get open() {
        return this.ifOpenService.open;
    }
/**
 * @param {?} ifOpenService
 * @param {?} template
 * @param {?} container
 */
constructor(private ifOpenService: IfOpenService,
private template: TemplateRef<any>,
private container: ViewContainerRef) {
        this.subscription = this.ifOpenService.openChange.subscribe((change) => {
            this.updateView(change);
            this.openChange.emit(change);
        });
    }
/**
 * ******
 * \@function updateView
 * 
 * \@description 
 * Function that takes a boolean value and either created an embedded view for the associated ViewContainerRef or,
 * Clears all views from the ViewContainerRef
 * @param {?} value
 * @return {?}
 */
public updateView(value: boolean) {
        if (value) {
            this.container.createEmbeddedView(this.template);
        } else {
            this.container.clear();
        }
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscription.unsubscribe();
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrIfOpen]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: IfOpenService, },
{type: TemplateRef, },
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'open': [{ type: Input, args: ["clrIfOpen", ] },],
'openChange': [{ type: Output, args: ["clrIfOpenChange", ] },],
};
}

function IfOpenDirective_tsickle_Closure_declarations() {
/** @type {?} */
IfOpenDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
IfOpenDirective.ctorParameters;
/** @type {?} */
IfOpenDirective.propDecorators;
/** @type {?} */
IfOpenDirective.prototype.subscription;
/**
 * *******
 * \@property openChange
 * 
 * \@description 
 * An event emitter that emits when the open property is set to allow for 2way binding when the directive is
 * used with de-structured / de-sugared syntax.
 * 
 * @type {?}
 */
IfOpenDirective.prototype.openChange;
/** @type {?} */
IfOpenDirective.prototype.ifOpenService;
/** @type {?} */
IfOpenDirective.prototype.template;
/** @type {?} */
IfOpenDirective.prototype.container;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
